import $ from 'jquery'

$('.events-filter button').on('click', function () {
  $('.events-filter button').not($(this)).removeClass('btn-darkest')
  $(this).addClass('btn-darkest')

  $('.events-target').hide()
  $($(this).attr('data-target')).show()
})
